import React, { useState } from "react";

import {
    Box,
    Flex,
    Text,
    Divider,
    Stack,
    Tooltip,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    IconButton,
    Icon,
    SimpleGrid,
    HStack
} from "@chakra-ui/react";

import {
    BadgeCheck,
    BadgeInfo,
    BadgeX,
    Download,
    Calendar,
    Phone,
    Mail,
    CreditCard,
    Users,
    Link2,
    MapPin,
    CheckCircle2,
    Clock3,
    XCircle,
    Calendar1,
} from "lucide-react";

import PdfIcon from "assets/svg/pdf.png";
import WordIcon from "assets/svg/word.png";
import ImageIcon from "assets/svg/jpg.png";

import NoDataFound from "components/NoDataGraphics/NoDataFound";
import DocumentViewer from "components/DocumentViewer/DocumentViewer";
import ReusableAvatar from "components/Avatar/ReusableAvatar";
import InfoRow from "components/InfoRow/InfoRow";

import { formatDate } from "utils/dateFormatter";

const DocumentIcon = ({ type }) => {
    switch (type) {
        case "pdf":
            return (
                <img
                    src={PdfIcon}
                    alt="PDF"
                    width={24}
                />
            );

        case "docx":
            return (
                <img
                    src={WordIcon}
                    alt="Word"
                    width={24}
                />
            );

        case "jpeg":
        case "jpg":
        case "png":
            return (
                <img
                    src={ImageIcon}
                    alt="Image"
                    width={24}
                />
            );

        default:
            return null;
    }
};

const ViewDriverPartner = ({ partner }) => {
    const [isOpen, setIsOpen] =
        useState(false);

    const [
        currentDocument,
        setCurrentDocument,
    ] = useState(null);

    if (!partner) return null;

    const driverPartner =
        partner.driver_partner;

    const user = partner.user;

    const BASE_URL =
        process.env.REACT_APP_API_BASE_URL;

    const documents =
        user?.documents || [];

    const profileImage =
        documents.find(
            (doc) =>
                doc.document_type ===
                "Profile Image"
        );

    const profileImageUrl =
        profileImage
            ? `${BASE_URL.replace(
                  /\/$/,
                  ""
              )}/${profileImage.file_path.replace(
                  /^\//,
                  ""
              )}`
            : null;

    const handleDocumentClick = (
        doc
    ) => {
        setCurrentDocument({
            url: `${BASE_URL.replace(
                /\/$/,
                ""
            )}/${doc.file_path.replace(
                /^\//,
                ""
            )}`,
            type: doc.file_extension,
            title: doc.document_type,
            dateUploaded:
                formatDate(
                    doc.uploaded_at
                ),
        });

        setIsOpen(true);
    };

    const closeModal = () => {
        setCurrentDocument(null);
        setIsOpen(false);
    };

    const openDocument = (url) =>
        window.open(
            url,
            "_blank",
            "noopener,noreferrer"
        );

const statusConfig = {
    Approved: {
        icon: BadgeCheck,
        color: "green.500",
    },
    Pending: {
        icon: BadgeInfo,
        color: "yellow.500",
    },
    Suspended: {
        icon: BadgeX,
        color: "orange.500",
    },
    Rejected: {
        icon: BadgeX,
        color: "red.500",
    },
    Deactivated: {
        icon: BadgeX,
        color: "gray.500",
    },
};

const currentStatus =
    statusConfig[driverPartner.status] ||
    statusConfig.Deactivated;

    return (
        <Flex
            direction="column"
            p={8}
        >
         <Flex align="center" mb={2}>
    <ReusableAvatar src={profileImageUrl} />

    <Box ml={4}>
        <Flex align="center">
            <Text
                fontSize="2xl"
                fontWeight="700"
            >
                {(user?.first_name &&
                    user?.last_name)
                    ? `${user.first_name} ${user.last_name}`
                    : user?.username ||
                      "Driver Partner"}
            </Text>

            <Icon
                as={currentStatus.icon}
                ml={2}
                boxSize={5}
                color={currentStatus.color}
                fill={currentStatus.color}
                stroke="white"
            />

            <Text
                ml={2}
                color={currentStatus.color}
                fontWeight="600"
                fontSize="sm"
            >
                {driverPartner.status}
            </Text>
        </Flex>

        <Flex align="center" mt={1}>
            <Icon
                as={MapPin}
                boxSize={3.5}
                color="gray.500"
                mr={1}
            />

            <Text
                fontSize="sm"
                color="gray.500"
            >
                {user?.village || "No village"}, Botswana
            </Text>
        </Flex>
    </Box>
</Flex>

                    <Box
                bgGradient="linear(to-r, blue.900, blue.700)"
                color="white"
                p={6}
                borderRadius="2xl"
            >
                <Text
                    fontSize="xs"
                    opacity={0.8}
                    textTransform="uppercase"
                    letterSpacing="1px"
                >
                    Referral Code
                </Text>

                <Text
                    fontSize="3xl"
                    fontWeight="800"
                    mt={1}
                >
                    {driverPartner.partner_referral_code}
                </Text>

            <HStack
                mt={6}
                spacing={10}
            >
                <Box>
                    <Text
                        fontSize="2xl"
                        fontWeight="700"
                    >
                        {partner?.stats?.total_referred_drivers ?? 0}
                    </Text>

                    <Text
                        fontSize="sm"
                        opacity={0.8}
                    >
                        Drivers Referred
                    </Text>
                </Box>

                <Box>
                    <Text
                        fontSize="2xl"
                        fontWeight="700"
                    >
                        {partner?.stats?.approved_drivers ?? 0}
                    </Text>

                    <Text
                        fontSize="sm"
                        opacity={0.8}
                    >
                        Approved
                    </Text>
                </Box>

                <Box>
                    <Text
                        fontSize="2xl"
                        fontWeight="700"
                    >
                        {partner?.stats?.pending_drivers ?? 0}
                    </Text>

                    <Text
                        fontSize="sm"
                        opacity={0.8}
                    >
                        Pending
                    </Text>
                </Box>
            </HStack>
        </Box>
             <Flex mt={2} alignItems="center">
                            <Icon as={Calendar1} size={16} color="gray.500" mr={1} />
                            <Text fontSize="sm" color="gray.500">
                                Date Joined: {formatDate(driverPartner.created_at)}
                            </Text>
                        </Flex>


            <Divider my={6} />

            <Text
                mb={4}
                color="gray.500"
                fontWeight="600"
            >
                Partner Information
            </Text>

            <Stack spacing={3}>
                <InfoRow
                    label="Email"
                    value={
                        user.email
                    }
                    icon={Mail}
                />

                <InfoRow
                    label="Phone Number"
                    value={
                        user.phone_number
                    }
                    icon={Phone}
                />

                <InfoRow
                    label="Payment Method"
                    value={
                        driverPartner.payment_method
                    }
                    icon={
                        CreditCard
                    }
                />

                <InfoRow
                    label="Payment Account"
                    value={
                        driverPartner.payment_account
                    }
                    icon={
                        CreditCard
                    }
                />

                <InfoRow
                    label="Referral Source"
                    value={
                        driverPartner.referral_source ||
                        "N/A"
                    }
                    icon={Users}
                />

                <InfoRow
                    label="Referral Link"
                    value={
                        driverPartner.partner_referral_link ||
                        "Not Generated"
                    }
                    icon={Link2}
                />

            </Stack>

            <Divider my={6} />

            <Text
                mb={4}
                color="gray.500"
                fontWeight="600"
            >
                Documents
            </Text>
            {documents.length > 0 ? (
                <Flex
                    wrap="wrap"
                    gap={4}
                    overflowX="auto"
                >
                    {documents.map((doc) => (
                        <Tooltip
                            key={doc.document_id}
                            label="Click to view"
                            hasArrow
                        >
                            <Box
                                w="calc(50% - 8px)"
                                p={3}
                                border="1px solid"
                                borderColor="gray.200"
                                borderRadius="md"
                                display="flex"
                                alignItems="center"
                                _hover={{
                                    bg: "gray.50",
                                    cursor: "pointer",
                                }}
                                onClick={() =>
                                    handleDocumentClick(
                                        doc
                                    )
                                }
                            >
                                <DocumentIcon
                                    type={
                                        doc.file_extension
                                    }
                                />

                                <Box ml={3}>
                                    <Text
                                        fontWeight="600"
                                    >
                                        {
                                            doc.document_type
                                        }
                                    </Text>

                                    <Text
                                        fontSize="sm"
                                        color="gray.500"
                                    >
                                        Uploaded{" "}
                                        {formatDate(
                                            doc.uploaded_at
                                        )}
                                    </Text>
                                </Box>
                            </Box>
                        </Tooltip>
                    ))}
                </Flex>
            ) : (
                <NoDataFound
                    message="No documents uploaded"
                    width="120px"
                    height="120px"
                />
            )}

            <Modal
                isOpen={isOpen}
                onClose={closeModal}
                size="4xl"
            >
                <ModalOverlay />

                <ModalContent>
                    <ModalHeader>
                        Document Viewer
                    </ModalHeader>

                    <ModalCloseButton />

                    <ModalBody pb={6}>
                        {currentDocument ? (
                            <>
                                <DocumentViewer
                                    documents={[
                                        currentDocument,
                                    ]}
                                />

                                <Flex
                                    justify="flex-end"
                                    mt={4}
                                >
                                    <IconButton
                                        aria-label="Open Document"
                                        icon={
                                            <Download />
                                        }
                                        onClick={() =>
                                            openDocument(
                                                currentDocument.url
                                            )
                                        }
                                        bg="#2453FF"
                                        color="white"
                                        _hover={{
                                            bg: "#1D4ED8",
                                        }}
                                    />
                                </Flex>
                            </>
                        ) : (
                            <NoDataFound message="No document selected" />
                        )}
                    </ModalBody>
                </ModalContent>
            </Modal>
        </Flex>
    );
};

export default ViewDriverPartner;